import { Fragment, type ReactNode } from 'react'

/**
 * Resalta las cifras de una oración envolviéndolas en `<b>`.
 *
 * El titular llega del contrato como texto plano (`titularFounder` devuelve
 * strings, no JSX, porque es una función pura sin React). Pero la dirección de
 * diseño pide prosa en `--muted-strong` con **solo las cifras en `--text`**: el
 * contraste de peso hace saltar los números sin agregar un color.
 *
 * Resaltar acá y no en el contrato mantiene la narrativa testeable sin DOM y
 * deja la decisión tipográfica del lado de la presentación, que es donde vive.
 *
 * Un token es una cifra: signo opcional (+ o el menos tipográfico −), `$`
 * opcional, un dígito, y después dígitos con puntos de miles y coma decimal,
 * con `%` o `x` opcional al final.
 */
const CIFRA = /([+−-]?\$?\d[\d.,]*(?:%|x)?)/g

/** Quita la puntuación de cierre que el regex se lleva pegada al número. */
function partirCola(token: string): [string, string] {
  const limpio = token.replace(/[.,]+$/, '')
  return [limpio, token.slice(limpio.length)]
}

export function resaltarCifras(texto: string): ReactNode {
  const partes = texto.split(CIFRA)

  return (
    <>
      {partes.map((parte, i) => {
        // split con grupo de captura alterna: los impares son las cifras.
        if (i % 2 === 0) return <Fragment key={i}>{parte}</Fragment>
        const [cifra, cola] = partirCola(parte)
        return (
          <Fragment key={i}>
            <b>{cifra}</b>
            {cola}
          </Fragment>
        )
      })}
    </>
  )
}
